<div class="deletePopup" style="font-family: Poppins;">
  <!-- <div class="d-flex justify-content-between align-items-center p-10">
        <h2 mat-dialog-title class="m-0">{{ data.title || 'Confirmation' }}</h2>

        <div class="p-2" style="margin: 0 0 -5px 0px !important;">
            <mat-icon mat-dialog-close class="close-icon" style="color: rgba(138, 152, 171, 1);" >close</mat-icon>
        </div>
    </div> -->
  <div class="d-flex justify-content-between align-items-center"
    style="background: #F6F8FB; color: #1363DF;     height: 40px;">
    <h2 mat-dialog-title class="m-0">{{ data.title || 'Confirmation' }}</h2>

    <mat-icon mat-dialog-close class="close-icon"
      style="color: #8A98AB; cursor: pointer; margin-right: 15px;">close</mat-icon>
  </div>
  <mat-dialog-content class="p-3" style="background-color: #ffffff;">
    <div class="p-3 rounded shadow-sm" style="background-color: #f9f9f9; border: 1px solid #e0e0e0;margin-top: 8px;">
      <!-- <h4 class="mb-3 text-primary">Details</h4> -->

      <div *ngFor="let item of formattedDetails" class="mb-2">
        <p class="mb-0"><strong style="font-size: 14px;font-weight: 600;font-family: poppins;">{{ item.key }}: </strong>
          <ng-container *ngIf="item.key === 'Selected_Period'; else normalField">
            <div *ngFor="let p of item.value" class="normal-text">
              - {{ p.day }} - {{ p.time }}, {{ p.selectedDate }}
            </div>
          </ng-container>
          <ng-template #normalField>
            <span class="normal-text"> {{ item.value }}</span>
          </ng-template>
        </p>
      </div>
        <!-- 👇 Add Textarea Here -->
      <div class="mt-3" *ngIf="isReason">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Reason</mat-label>
          <textarea
            matInput
            [(ngModel)]="reason"
            minlength="10"
            #commentsCtrl="ngModel"
            required>
          </textarea>

          <!-- error message -->
          <mat-error *ngIf="commentsCtrl.invalid && commentsCtrl.touched">
            Minimum 10 characters required.
          </mat-error>
        </mat-form-field>
      </div>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="px-3 pb-3">
    <div class="d-flex gap-2 justify-content-center w-100">
      <button mat-flat-button style="background-color: #1363DF; color: white;" class=" px-4 action-btn-size"
        (click)="closeDialog(true)" [disabled]="isReason && (!reason || reason.length < 10)">
        Yes
      </button>
      <button mat-stroked-button style="color: #E70D0D;" class=" px-4 action-btn-size" (click)="closeDialog(false)">
        No
      </button>
    </div>
  </mat-dialog-actions>

</div>